import { render, staticRenderFns } from "./our-team.vue?vue&type=template&id=c908116e&scoped=true&"
import script from "./our-team.vue?vue&type=script&lang=js&"
export * from "./our-team.vue?vue&type=script&lang=js&"
import style0 from "./our-team.vue?vue&type=style&index=0&id=c908116e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c908116e",
  null
  
)

export default component.exports